import Box from "@mui/material/Box"
import { SHOW_VIDEO_COUNT } from "app-constants/constants"
import Card from "components/Card"
import InfiniteHorizontalScroller from "components/InfiniteHorizontalScroller"
import { ActivityIndicator } from "components/activity-indicator"
import { Filter } from "models/convention-api/types"
import ConventionVideo from "models/convention-api/v1/ConventionVideo"
import pluralize from "pluralize"

interface IVideosList {
  filter: Filter
}

const VideosList = (props: IVideosList) => {
  const { filter } = props

  const videos = ConventionVideo.useMore(() => {
    return {
      filter,
      includes: ["institution", "video_count"],
      includeCount: true,
    }
  })

  if (!videos.data) {
    return (
      <Box display="flex" flexDirection="column" minHeight="400px">
        <ActivityIndicator />
      </Box>
    )
  }

  if (videos.data.length === 0) return <></>

  return (
    <InfiniteHorizontalScroller
      hasMore={videos.hasMore}
      loadMore={videos.loadMore}
      loading={videos.isLoadingMore}
      title={`${pluralize("Video", videos.count)} (${videos.count})`}
      emptyStateMessage="No videos found">
      {videos.data.map((video) => {
        const viewCount = video.video_count?.video_count
        return (
          <Card
            key={video.id}
            imageUrl={video.thumbnail_url}
            title={video.name}
            subTitle={video.institution?.name || "N/A"}
            footerText={SHOW_VIDEO_COUNT ? `${viewCount} ${pluralize("view", viewCount)}` : ""}
            redirect={`/videos/${video.id}`}
            size={250}
            height={250}
            mediaHeight={120}
            subFontSize={14}
          />
        )
      })}
    </InfiniteHorizontalScroller>
  )
}

export default VideosList
